"use client";

import { c as _c } from "react/compiler-runtime";
import { Switch } from "@/components/ui/switch";
import type { ConnectorType } from "@/stores/connectorsStore";
import { PixelLoader } from "@/components/ui/pixel-loader";
import Link from "next/link";
import { ConnectorLogo } from "./ConnectorLogo";
import { connectorTypeToIntegrationSlug } from "@/lib/connectors/slug";
interface AvailableConnectorRowProps {
  connectorType: ConnectorType;
  onAdd: (type: string) => void;
  isConnecting?: boolean;
  isConnected?: boolean;
  onManage?: () => void;
}
export function AvailableConnectorRow(t0) {
  const $ = _c(31);
  const {
    connectorType,
    onAdd,
    isConnecting,
    isConnected,
    onManage
  } = t0;
  let t1;
  if ($[0] !== connectorType.type || $[1] !== isConnected || $[2] !== onAdd || $[3] !== onManage) {
    t1 = () => {
      if (isConnected && onManage) {
        onManage();
      } else {
        onAdd(connectorType.type);
      }
    };
    $[0] = connectorType.type;
    $[1] = isConnected;
    $[2] = onAdd;
    $[3] = onManage;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleActivate = t1;
  let t2;
  if ($[5] !== connectorType.logoUrl || $[6] !== connectorType.name || $[7] !== connectorType.type) {
    t2 = <div className="ds-logo-wrapper"><ConnectorLogo type={connectorType.type} name={connectorType.name} logoUrl={connectorType.logoUrl} size="base" /></div>;
    $[5] = connectorType.logoUrl;
    $[6] = connectorType.name;
    $[7] = connectorType.type;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== connectorType.name) {
    t3 = <p className="text-ds-text-secondary truncate font-mono text-base font-medium uppercase">{connectorType.name}</p>;
    $[9] = connectorType.name;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = connectorType.description || "No description available";
  let t5;
  if ($[11] !== t4) {
    t5 = <p className="body-sm mt-0.5 truncate">{t4}</p>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <div className="min-w-0 flex-1">{t3}{t5}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <div className="flex min-w-0 flex-1 items-center gap-4">{t2}{t6}</div>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = `/integrations/app/${connectorTypeToIntegrationSlug(connectorType.type)}`;
  let t9;
  if ($[19] !== t8) {
    t9 = <Link href={t8} className="text-ds-text-secondary hover:text-ds-text-primary text-sm font-medium transition-colors dark:hover:text-zinc-100">View integration</Link>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== handleActivate || $[22] !== isConnected || $[23] !== isConnecting) {
    t10 = isConnecting ? <PixelLoader size="sm" color="blue" /> : <Switch checked={isConnected} onCheckedChange={handleActivate} size="sm" />;
    $[21] = handleActivate;
    $[22] = isConnected;
    $[23] = isConnecting;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = <div className="flex shrink-0 items-center gap-4">{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t7) {
    t12 = <div className="border-ds-neutral-200/80 dark:border-ds-neutral-800/80 flex items-center gap-4 border-b py-4 last:border-b-0">{t7}{t11}</div>;
    $[28] = t11;
    $[29] = t7;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}